import MoAuth from '@mo-platform/auth'

const auth = new MoAuth({
  'authUrl': process.env.VUE_APP_BOOKSYNC_URL,
  'loginUrl': `${process.env.VUE_APP_BOOKSYNC_URL}/auth/login?api_key=${process.env.VUE_APP_API_KEY}`,
  'userFetchUrl': `${process.env.VUE_APP_BOOKSYNC_URL}/api/user`,
  'logoutUrl': `${process.env.VUE_APP_EPORTAL_LOGOUT_URL}?redirect_url=${encodeURIComponent(process.env.VUE_APP_BASE_URL)}`
})

export default auth
